export default "__VITE_ASSET__CKEaFdr3__"